export default "__VITE_ASSET__r_WVoSzsPqTwSQW9l5Tx6g__"